import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify"; // Using toastify as per your bullion example
import {
  fetchOfferConfigRequest,
  fetchOfferConfigSuccess,
  fetchOfferConfigFailure,
  saveOfferConfigRequest,
  saveOfferConfigSuccess,
  saveOfferConfigFailure,
} from "./OfferSlice";

function* fetchOfferConfigSaga(action) {
  try {
    const { name } = action.payload;
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getofferdetails/${name}`
    );
    yield put(fetchOfferConfigSuccess({ name, data: response.data?.data }));
    // Optional: toast.success("Data loaded"); 
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message;
    yield put(fetchOfferConfigFailure(errorMsg));
    toast.error(`Failed to fetch ${action.payload.name}: ${errorMsg}`);
  }
}

function* saveOfferConfigSaga(action) {
  try {
    const { name, value, callback } = action.payload;
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveofferdetails`,
      { name, value }
    );

    yield put(saveOfferConfigSuccess());
    toast.success(response.data?.message || "Configuration saved successfully");

    if (typeof callback === "function") {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message;
    yield put(saveOfferConfigFailure(errorMsg));
    toast.error(`Save failed: ${errorMsg}`);
  }
}

export function* OfferSaga() {
  yield takeLatest(fetchOfferConfigRequest.type, fetchOfferConfigSaga);
  yield takeLatest(saveOfferConfigRequest.type, saveOfferConfigSaga);
}